module.exports = __webpack_public_path__ + "media/images/vp/samples/02-d54230192d6d7c55d1e8e97fe87cbaa4.jpg";